<div class="component-container"
     id="weight-chart-container">
  <div *ngIf="printData?.userName" class="heading">
    <div class="title">
      {{ printData?.userName }}
    </div>
  </div>
  <div
    class="heading flex xs:flex-col sm:flex-row md:flex-row justify-between items-center">
    <div class="title">
      {{ !memberId ? 'My ' : '' }}Weight
      <span class="additional-text">{{ additionalText }}</span>
    </div>
    <div class="controls flex flex-row justify-between items-center">
      <mat-checkbox
        (change)="onRoleToggle(item)"
        *ngFor="let item of legendList"
        [checked]="item.checked"
        [disabled]="chartTableData?.loading"
        [style]="{'--checkbox-color': item.color}"
      >
        {{ item.label }}
      </mat-checkbox>
    </div>
  </div>
  <div
    class="chart-container flex-row flex w-full xs:h-[50rem] sm:h-[50rem] md:h-[50rem]">
    <div *ngIf="chartData?.loading"
         class="chart-loader w-full h-full flex justify-center items-center">
      <mat-spinner
        [diameter]="60"
        strokeWidth="5"
      />
    </div>
    <line-chart *ngIf="chartData?.data"
                chartName="weight-chart"
                [chartData]="chartData.data"
                [xAxisLabel]="'Date'"
                [yAxisLabel]="'Pounds'"
                class="w-full"
    ></line-chart>
    <div *ngIf="!chartData?.loading && !chartData?.data"
         class="no-chart-data w-full h-full flex justify-center items-center">
      No data to show on chart.
    </div>
  </div>
  <div class="table-container w-full">
    <div class="w-full xs:overflow-x-auto sm:overflow-x-auto">
      <div (scrolled)="onScroll()"
           [fromRoot]="true"
           [immediateCheck]="true"
           [infiniteScrollDisabled]="!chartData?.data"
           [infiniteScrollDistance]="2"
           [infiniteScrollThrottle]="10"
           [scrollWindow]="false"
           class="table-wrapper table-container xs:w-[80rem] sm:w-[80rem] md:w-full {{printData?'':'xs:max-h-[85vh] sm:max-h-[85vh] md:max-h-[calc(90vh-6rem)] xl:max-h-[calc(95vh-6rem)] overflow-auto'}}"
           infiniteScroll>
        <table *ngIf="chartTableData?.data?.list?.length"
               [dataSource]="chartTableData?.data?.list"
               mat-table>
          <ng-container matColumnDef="addedBy">
            <th *matHeaderCellDef
                mat-header-cell
                class="w-[33.33%]"> Captured by
            </th>
            <td
              *matCellDef="let element"
              mat-cell
              class="w-[33.33%]">

              <div
                class="role-color-circle-container flex flex-row items-center">
                <div
                  [style]="{ 'background-color':
                    roleDecorators[element.isCoachEntered ? 1 : 2].color}"
                  class="role-color-circle w-[0.8rem] h-[0.8rem]"></div>
                <span
                  [matTooltip]="element.addedBy.firstName+ ' ' +
                            element.addedBy.lastName"
                  matTooltipClass="metric-role-tooltip">{{ roleDecorators[element.isCoachEntered ? 1 : 2].label }}</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="recordedOn">
            <th *matHeaderCellDef
                class="w-[33.33%] sortable-header cursor-pointer"
                mat-header-cell
                (click)="onSort('recordedOn')"> 
              Measurement Date
              <span class="sort-indicator">
                <ng-container *ngIf="sortColumn === 'recordedOn'">
                  <span *ngIf="sortOrder === 'asc'">↑</span>
                  <span *ngIf="sortOrder === 'desc'">↓</span>
                </ng-container>
              </span>
            </th>
            <td *matCellDef="let element"
                mat-cell
                class="w-[33.33%]"> {{
                element.recordedOn |
                  date:'MMM dd, yyyy'
              }}
            </td>
          </ng-container>

<!--          <ng-container matColumnDef="sessions">-->
<!--            <th-->
<!--              mat-header-cell-->
<!--              class="w-[25%]"-->
<!--              *matHeaderCellDef-->
<!--            >-->
<!--              Session-->
<!--            </th>-->
<!--            <td-->
<!--              style="-->
<!--                min-width: 12rem;-->
<!--                max-width: 18rem;-->
<!--                overflow: visible;-->
<!--                white-space: nowrap;-->
<!--              "-->
<!--              class="sessions-cell w-[25%]"-->
<!--              mat-cell-->
<!--              *matCellDef="let element"-->
<!--            >-->
<!--              <ng-container *ngIf="element.sessions?.length; else noSessions">-->
<!--                <div-->
<!--                  *ngFor="let session of element.sessions"-->
<!--                  class="td-cell session flex flex-col gap-[1rem]"-->
<!--                >-->
<!--                  <div-->
<!--                    *ngIf="session['sessionNumber']"-->
<!--                    class="session flex flex-row justify-start items-center gap-x-[1rem]"-->
<!--                  >-->
<!--                    <span class="pill-container">-->
<!--                      S{{ session.sessionNumber | number: "2.0-0" }}-->
<!--                    </span>-->
<!--                    <span class="session-date">-->
<!--                      {{ session.date | date: "MMM dd" }}-->
<!--                    </span>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </ng-container>-->
<!--              <ng-template #noSessions>-->
<!--                <span>-</span>-->
<!--              </ng-template>-->
<!--            </td>-->
<!--          </ng-container>-->

          <ng-container matColumnDef="value">
            <th *matHeaderCellDef
                mat-header-cell
                class="w-[33.33%]">Weight (pounds)
            </th>
            <td *matCellDef="let element"
                mat-cell
                class="w-[33.33%]"> {{ element.value }}
            </td>
          </ng-container>

          <tr *matHeaderRowDef="columns; sticky: true"
              mat-header-row></tr>
          <tr *matRowDef="let row; columns: columns"
              mat-row></tr>
          <tr *matNoDataRow
              class="mat-row">
            <td [colSpan]="columns.length"
                class="mat-cell">
              No data found.
            </td>
          </tr>
        </table>

        <div *ngIf="chartData?.data&&chartTableData?.loading"
             class="chart-table-loader w-full h-[10rem] flex justify-center items-center">
          <mat-spinner
            [diameter]="60"
            strokeWidth="5"
          />
        </div>
      </div>
    </div>
  </div>
</div>
